import PropTypes from "prop-types";
import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { CopyButton, TextInput } from '@opendate-app/setlist';

const EventQrCodeApp = ({
  teamId,
  confirmId,
  eventTitle,
  publicTicketingUrl,
  downloadUrls,
}) => {
  return (
    <div className="container py-4">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <div className="card shadow-sm">
            <div className="card-body text-center p-4">
              <h2 className="h4 mb-1">{eventTitle}</h2>
              <p className="text-muted mb-4">
                Scan to buy tickets on a phone
              </p>

              <div
                className="d-inline-block p-3 bg-white border rounded mb-3"
                aria-label="Event purchase QR code"
              >
                <QRCodeSVG
                  value={publicTicketingUrl}
                  size={320}
                  level="M"
                  style={{ display: "block" }}
                />
              </div>

              <div className="mb-4">
                <TextInput
                  size="sm"
                  aria-label="Public ticketing URL"
                  value={publicTicketingUrl}
                  readOnly
                  onFocus={(e) => e.target.select()}
                  trailingButton={<CopyButton size="sm" value={publicTicketingUrl} />}
                />
              </div>

              <div>
                <p className="font-weight-bold mb-2">Download</p>
                <div className="btn-group" role="group" aria-label="Download QR code">
                  <a
                    href={downloadUrls.png}
                    className="btn btn-primary"
                    download
                  >
                    <i className="fas fa-image mr-1"></i> PNG
                  </a>
                  <a
                    href={downloadUrls.svg}
                    className="btn btn-primary"
                    download
                  >
                    <i className="fas fa-vector-square mr-1"></i> SVG
                  </a>
                  <a
                    href={downloadUrls.pdf}
                    className="btn btn-primary"
                    download
                  >
                    <i className="fas fa-file-pdf mr-1"></i> PDF
                  </a>
                </div>
              </div>
            </div>
          </div>

          <p className="text-muted text-center small mt-3 mb-0">
            Display this QR code at the door so walk-up attendees can buy
            tickets on their phones.
          </p>
        </div>
      </div>
    </div>
  );
};

EventQrCodeApp.propTypes = {
  teamId: PropTypes.number.isRequired,
  confirmId: PropTypes.number.isRequired,
  eventTitle: PropTypes.string.isRequired,
  publicTicketingUrl: PropTypes.string.isRequired,
  downloadUrls: PropTypes.shape({
    png: PropTypes.string.isRequired,
    svg: PropTypes.string.isRequired,
    pdf: PropTypes.string.isRequired,
  }).isRequired,
};

export default EventQrCodeApp;
